import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import {SectionTitle} from '../components/SectionTitle';
import { theme } from '../Template';
import Carousel from 'react-elastic-carousel';
import ServiceCard from '../components/ServiceCard';
import { LocationOnOutlined, EmailOutlined, PhoneOutlined } from '@mui/icons-material';
import Header from '../components/Header';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import CustomButton from '../../Template3/components/CustomButton';
import { useCompanyData } from '../../shared/contexts/DataContext';
import Map from '../../shared/components/Map';
import imgProfile from '../../../../../assets/images/templates/profile.jpg';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { aboutImage, bannerImage } from '../../shared/logic/imagesFns';
import SocialIcons from '../../shared/components/SocialIcons';
import GetImageDimensions from '../../shared/logic/getImgDimensions';
import * as Components from '../../shared/sections';
import { HomeHeader } from '../../Template3/screens/Home';
import SectionLayout from '../../shared/layout/SectionLayout';
import { textVariant, textClasses } from '../../shared/config';
import '../../shared/styles.css'
import CourseCard from '../components/CourseCard';

const useStyles = makeStyles(() => ({
  carousel: {
    position: 'relative',
    '& .rec.rec-arrow': {
      position: 'absolute',
      backgroundColor: 'white',
      zIndex: '10',
      top: '38%',
      border: 'none',
      borderRadius: 0,
    },
    '& .rec.rec-dot': {
      display: 'none',
    },
    '& .rec.rec-arrow:last-child': {
      right: 0,
    },
    '& .rec.rec-arrow:hover': {
      backgroundColor: '#C31B37',
    },
    '& .rec.rec-arrow:disabled': {
      visibility: 'hidden',
    },
  },

  tp:{
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    // fontFamily:"'Cairo', sans-serif"
  },

  showBtn:{
    color: '#0F467A',
    fontSize: '13px',
    marginLeft: '8px',
    cursor:'pointer',
    fontFamily:'inherit'
  },

  descDiv:{
    alignSelf: 'center',
    outline: 'none',
    border: 'none',
    width: '100%',
    margin: '10px 0px',
    color:'#000',
    fontFamily: 'inherit',
    borderRadius: '8px',
    boxSizing:"border-box"
  },

  aboutImg:{
    boxShadow: '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": '0px 0px 30px rgb(209,209,209)'
  }
}));

const Home = () => {
  const { data } = useCompanyData();
  const { t, mainColor, companyDomain, fontFamily, homepageSections, aboutSectionStyle } = data || {};
  const { id } = useParams();
  const navigate = useNavigate();

  const handleExploreServices = () => {
    navigate(companyDomain ? '/temp/services' : `/${id}/temp/services`);
  };

  const handleExploreCategories = () => {
    navigate(companyDomain ? '/temp/categories' : `/${id}/temp/categories`);
  };
  const maxServiceShow = data && data.maxDisplayItems ? data.maxDisplayItems : 100;

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[]);

  const ComponentLists = {
    ...Components,
    'About': About,
    'Services': Services,
    'Courses': Courses,
    'Teams': Teams
  };

  const staticProps = {
    aboutName: data.companyData?.name,
    aboutImage: aboutImage(data),
    aboutTitle: data?.aboutTitle || '',
    aboutDescription: data.description ? data.description :  data?.companyData?.description,
    arAboutTitle: data?.arAboutTitle || '',
    arAboutDescription: data?.arAboutDescription || '',
    aboutBackgroundColor: aboutSectionStyle && aboutSectionStyle?.backgroundColor ? aboutSectionStyle?.backgroundColor : 'transparent',
    aboutBackgroundImage: aboutSectionStyle && aboutSectionStyle?.backgroundImage ? aboutSectionStyle?.backgroundImage : '',
    aboutBackgroundStyle: aboutSectionStyle && aboutSectionStyle?.backgroundStyle ? aboutSectionStyle?.backgroundStyle : '',
    aboutSectionStyle,
    courses: data.courses || [],
    services: data.products || [],
    categories: data.categories || [],
    teamMembers: data.teams || [],
    companyData: data.companyData,
    companyEmail: data?.companyEmail,
    productDisplayHorizontal: data?.productDisplayHorizontal || false,
    displayDescription: data.displayProductDesc !== undefined ? data.displayProductDesc : true,
    handleExploreCategories,
    handleExploreServices,
    maxServiceShow,
    mainColor,
    data,
    t,
  };

  return (
    <div>
      <HomeHeader 
        {...{
          headerTitle:data.companyData?.name,
          data
        }}
      />
      {homepageSections?.length ?
        React.Children.toArray(homepageSections.map(v => {
          const _compName = v?.ComponentName;
          const componentName = _compName === "Content" ? `${_compName}${v?.design || 1}` : ['Services','Courses']?.includes(_compName) && v?.design ? `${_compName}${v?.design || 1}` : _compName;
          const DynamicComponent = v.visible ? ComponentLists[componentName] : ComponentLists['EmptyComponent'];
          return <DynamicComponent {...staticProps} contentData={v.content || {}} productType={v.value} />
        }))
      : 
      <>
        <About {...staticProps} />
        <Services {...staticProps} productType='services' />
        <Teams {...staticProps} />
        <Contact {...staticProps} />
      </>
      }
    </div>
  );
};

function _HomeHeader({
  headerTitle,
  data
}) {
  const { bannerSubTitle,bannerFontColor, bannerTitleDirection, bannerSpaceBetween, bannerImageSize, bannerPaddingBottom, bannerPaddingTop, fontFamily, bannerMaxHeight, bannerAlignment, spaceBetweenContent, isRTL, titleFontSize, showHeaderSocialIcon=true, displayBanner=true, demoHeader, generalTitleFontSize,
   } = data || {};

  const title = isRTL === 'ar' && data?.arBannerTitle ? data?.arBannerTitle : data?.bannerTitle ||  headerTitle;


  return(
    <Header
    // height="500px"
    image={bannerImage(data)}
    data={data}
    transparencyColor={data.transparentLayer ? `${data.transparentLayer}${data.transparency ? data.transparency : 'B2'}` : '#15476db2'}
    bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
    displayBanner={displayBanner}
    titleColor={data.bannerFontColor}
    page="home"
    title={title}
  />
  )
}

function About({ aboutTitle, aboutName, aboutImage, aboutDescription, arAboutTitle, arAboutDescription, aboutBackgroundColor, aboutBackgroundImage, aboutBackgroundStyle, t, data, mainColor, aboutSectionStyle }) {
  const isMounted = React.useRef(null);
  const [imageDimensions, setImageDimensions] = React.useState({});
  const navigate = useNavigate();
  const { pathname:url } = useLocation();
  const { companyDomain, isRTL, generalParagraphFontSize, generalParagraphColor, buttonFontSize } = data || {};
  const [showLess, setShowLess] = React.useState(true);
  const textLength = 800;
  const classes = useStyles();
  const { titleFormat, titleFontSize, descriptionFontSize, titleFontColor, textFontColor, paddingTop, paddingBottom } = aboutSectionStyle || {};
  const _descriptionFontSize = descriptionFontSize ? descriptionFontSize : generalParagraphFontSize ? generalParagraphFontSize : '16';
  const descFontColor = textFontColor ? textFontColor : generalParagraphColor ? generalParagraphColor : '#000';
  const matches720 = useMediaQuery('(min-width:720px)');

  const desc = isRTL === 'ar' && arAboutDescription ? arAboutDescription : aboutDescription;
  const title = isRTL === 'ar' && arAboutTitle ? arAboutTitle : aboutTitle || t && t('companyPage.aboutus');

  React.useEffect(() => {
    isMounted.current = true;
    function run() {
      if(isMounted.current) {
        GetImageDimensions(setImageDimensions, aboutImage);
      }
    };

    run();
    return () => isMounted.current = false;
  }, [aboutImage]);
  
  return (
    <div style={{
      width:'100%',
      ...(aboutBackgroundStyle === 'image' && aboutBackgroundImage ?
        {
          backgroundImage: `url(${aboutBackgroundImage})`,
          backgroundSize: "cover"
        }
        :
        aboutBackgroundStyle === 'gradient' ? 
        {backgroundImage: aboutBackgroundColor} 
        : {backgroundColor: aboutBackgroundColor}
      )
    }}>
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Box
        width="100%"
        margin="auto"
        display="flex"
        justifyContent={matches720 ? 'space-between' : 'center'}
        alignItems="center"
        flexWrap="wrap"
      >
        <Box width={matches720 ? '49%' : '100%'} textAlign={!matches720 ? 'center' : 'initial'}>
          <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''}>{title}</SectionTitle>
          <Box pb={3} color={descFontColor}>
            <Typography
              variant={_descriptionFontSize && textVariant?.[_descriptionFontSize] ? textVariant?.[_descriptionFontSize] : textVariant?.['16']}
              className={_descriptionFontSize && textClasses?.[_descriptionFontSize] ? textClasses?.[_descriptionFontSize] : textClasses?.['16']}
            >
            {desc && desc.length < textLength ?
                  <span className={classes.tp}>{desc}</span>
                :
                showLess ?
                  <>
                  <span className={classes.tp}>{desc && desc.slice(0,textLength)}</span>
                  <span className={classes.showBtn} style={{fontFamily:'inherit'}} onClick={()=> setShowLess(false)}>{t && t('companyPage.showmore')}</span>
                  </>
                :
                  <>
                  <span variant="body1" className={classes.tp}>{desc}</span>
                  <span className={classes.showBtn} style={{fontFamily:'inherit'}} onClick={()=> setShowLess(true)}>{t && t('companyPage.showless')}</span>
                  </>
              }
              </Typography>
          </Box>
          <Box pb={2}>
            <Button
              onClick={() => navigate(companyDomain ? `/temp/contact` : `${url}/temp/contact`)}
              size="large"
              variant="contained"
              color="primary"
              style={{backgroundColor:mainColor? mainColor : ''}}
              className={buttonFontSize && textClasses?.[buttonFontSize] ? textClasses?.[buttonFontSize] : '16'}
            >
              {t && t('companyPage.contactus')}
            </Button>
          </Box>
        </Box>
        {aboutImage && (
          <Box
            width="auto"
            maxWidth="45%"
            height="auto"
            maxHeight="433px"
            overflow="hidden"
            borderRadius="15px"
            className={classes.aboutImg}
          >
            <ImgLazyLoad>
              <img
                style={{
                  width:"100%",
                  height:"auto",
                  maxHeight: "433px",
                  borderRadius:"15px",
                  ...(imageDimensions?.height > 1280 ? {objectFit:'cover'} : {})
                }}
                src={aboutImage}
                alt={aboutName || 'about'}
              />
            </ImgLazyLoad>
          </Box>
        )}
      </Box>
      </SectionLayout>
    </div>
  );
}

function Services({ services, categories, t, handleExploreServices, handleExploreCategories, data, productType, mainColor, contentData }) {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { isRTL } = data || {};
  const { maxDisplayItems, displayProductDesc, productDisplayHorizontal = true, backgroundColor, backgroundImage, backgroundStyle, categoryId, title, arTitle, selectedCategories, titleFormat, titleFontSize, titleFontColor, paddingTop, paddingBottom } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;
  const maxServiceShow = maxDisplayItems ? maxDisplayItems : 100;

  const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : productType === 'categories' ? t && t('companyPage.category') : t && t('companyPage.services');

  const servicesDuplicate = services?.length ? JSON.parse(JSON.stringify(services)) : [];
  const filterService = servicesDuplicate?.length && categoryId && servicesDuplicate.filter(v=> v.serviceCategoryId === categoryId)?.length ? 
  servicesDuplicate.filter(v=> v.serviceCategoryId === categoryId) : 
  servicesDuplicate;

  const filteredSelectedCategory = selectedCategories?.length && categories ?  categories?.filter(category => selectedCategories.includes(category.id)) : [];
  const { setPage, count, currentItems } = useMyPagination(productType === 'categories' ? filteredSelectedCategory?.length ? filteredSelectedCategory?.slice(0,maxServiceShow) : categories.slice(0,maxServiceShow) : filterService.slice(0,maxServiceShow), 3);
  const listItem = productType === 'categories' ? selectedCategories?.length && filteredSelectedCategory?.length ? filteredSelectedCategory : categories : filterService;
  const iterableList = productDisplayHorizontal ? currentItems : listItem.slice(0,maxServiceShow);
  const companyId = data.companyData ? data.companyData.companyId : '';

  return (
    <div style={{
        width:'100%',
        ...(backgroundStyle === 'image' && backgroundImage ?
          {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundRepeat: 'no-repeat',
          }
          :
          backgroundStyle === 'gradient' ? 
          {backgroundImage: backgroundColor} 
          : {backgroundColor: backgroundColor || 'transparent'}
        )
      }}
    >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Box width="100%" margin="auto">
        <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''}>{_title}</SectionTitle>
          <Box display="flex" justifyContent={'center'} flexWrap="wrap">
            {iterableList?.map((item, i) => (
              <ServiceCard key={i} service={item} {...{displayDescription,productType,companyId,contentData}} />
            ))}
          </Box>

          {productDisplayHorizontal ? <MyPagination count={count} onChange={setPage} /> : null }
          {/* {productType === 'services' ?
          <Box textAlign="center" display="flex" flexDirection="column" alignItems={matches ? 'flex-end' : 'center'}>
            <Button
              onClick={productType === 'categories' ? handleExploreCategories : handleExploreServices}
              size="large"
              variant="contained"
              color="primary"
              style={{backgroundColor:mainColor? mainColor : ''}}
            >
              {t && t('companyPage.exploreServices')}
            </Button>
          </Box>
          : null} */}
      </Box>
      </SectionLayout>
    </div>

  );
}

function Courses({ courses, t, data, contentData }) {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { isRTL } = data || {};
  const { maxDisplayItems, displayProductDesc, productDisplayHorizontal = true, backgroundColor, backgroundImage, backgroundStyle, categoryId, title, arTitle, titleFormat, titleFontSize, titleFontColor, paddingTop, paddingBottom } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;
  const maxServiceShow = maxDisplayItems ? maxDisplayItems : 100;

  const coursesDuplicate = courses?.length ? JSON.parse(JSON.stringify(courses)) : [];
  const filterCourse = coursesDuplicate?.length && categoryId && coursesDuplicate.filter(v=> v.courseCategoryId === categoryId)?.length ? 
  coursesDuplicate.filter(v=> v.courseCategoryId === categoryId) : 
  coursesDuplicate;

  const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : t && t('courses.title');

  const { setPage, count, currentItems } = useMyPagination(filterCourse.slice(0,maxServiceShow), 3);
  const listItem = filterCourse;
  const iterableList = productDisplayHorizontal ? currentItems : listItem.slice(0,maxServiceShow);
  const companyId = data.companyData ? data.companyData.companyId : '';

  return (
    <div style={{
        width:'100%',
        ...(backgroundStyle === 'image' && backgroundImage ?
          {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundRepeat: 'no-repeat',
          }
          :
          backgroundStyle === 'gradient' ? 
          {backgroundImage: backgroundColor} 
          : {backgroundColor: backgroundColor || 'transparent'}
        )
      }}
    >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" margin="auto">
          <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''}>{_title}</SectionTitle>
            <Box display="flex" justifyContent={'center'} flexWrap="wrap">
              {iterableList?.map((item, i) => (
                <CourseCard key={i} service={item} {...{displayDescription,companyId,contentData}} />
              ))}
            </Box>

            {productDisplayHorizontal ? <MyPagination count={count} onChange={setPage} /> : null }
        </Box>
      </SectionLayout>
    </div>
  );
}

function Teams({ teamMembers, t, mainColor, contentData, data }) {
  const classes = useStyles();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];
  const [isExpanded, setIsExpanded] = useState(false);
  const { backgroundColor, backgroundImage, backgroundStyle, titleFormat, titleFontSize, titleFontColor, paddingTop, paddingBottom } = contentData || {};

  if(teamMembers?.length) 
  return (
    <div
      style={{
        width:'100%',
        ...(backgroundStyle === 'image' && backgroundImage ?
          {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover"
          }
          :
          backgroundStyle === 'gradient' ? 
          {backgroundImage: backgroundColor} 
          : {backgroundColor: backgroundColor || 'transparent'}
        )
      }}
    >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Box width="100%" margin="auto" position="relative">
        <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''}> {t && t('companyPage.team')}</SectionTitle>

        {matches ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
          >
            <Carousel className={classes.carousel} breakPoints={breakPoints}>
              {teamMembers.map((item, i) => (
                <TeamMember key={i} member={item} mainColor={mainColor} data={data} />
              ))}
            </Carousel>
          </Box>
        ) : (
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            {teamMembers
              ?.slice(0, isExpanded ? teamMembers.length : 3)
              ?.map((item, i) => (
                <TeamMember key={i} member={item} mainColor={mainColor} data={data} />
              ))}
          </Box>
        )}
      </Box>
      {!matches && (
        <Box textAlign="center" pb={3}>
          {isExpanded ? (
            <Button
              size="large"
              variant="contained"
              color="primary"
              style={{backgroundColor: mainColor ? mainColor : ''}}
              onClick={() => setIsExpanded(false)}
            >
              {t && t('companyPage.seeLess')}
            </Button>
          ) : (
            <Button
              size="large"
              variant="contained"
              color="primary"
              style={{backgroundColor: mainColor ? mainColor : ''}}
              onClick={() => setIsExpanded(true)}
            >
              {t && t('companyPage.seeMore')}
            </Button>
          )}
        </Box>
      )}
      </SectionLayout>
    </div>
  );

  return null;
}

function Contact({ companyData, companyEmail, t, data }) {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { address, phoneNumber, city } = companyData || {};
  const visibleMap = data && data.map !== undefined ? data.map : true;
  const visiblePhone = data.phone;


  return (
    <SectionLayout>
    <Box width="100%" margin="auto">
      <SectionTitle> {t && t('companyPage.contactus')}</SectionTitle>
      <Box
        display="flex"
        flexDirection={matches ? 'row' : 'column'}
        alignItems={matches ? 'center' : 'flex-start'}
        minHeight="300px"
        bgcolor="white"
      >
        <Box py={4} pl={9} pr={2} width="40%" minWidth="300px">
          <Box pb={2}>
            <Typography
              variant="h6"
              style={{ fontWeight: 600 }}
              color="textSecondary"
            >
              {t && t('companyPage.getInTouch')}
            </Typography>
          </Box>

          <div>
            {visibleMap ? 
            <Box display="flex" alignItems="center" pb={1}>
              <Box color="#E9A9B4">
                <LocationOnOutlined style={{ fontSize: '2rem' }} />
              </Box>
              <Typography
                variant="body1"
                style={{ margin: '0 1em' }}
              >{`${address} ${city}`}</Typography>
            </Box>
            : null }
            {visiblePhone && phoneNumber ?
            <Box display="flex" alignItems="center" pb={1}>
              <Box color="#E9A9B4">
                <PhoneOutlined style={{ fontSize: '2rem' }} />
              </Box>
              <a href={`tel:${phoneNumber}`}>
                <Typography variant="body1" style={{ margin: '0 1em' }}>
                  {phoneNumber}
                </Typography>
              </a>
            </Box>
            : null }
            {companyEmail ?
            <Box display="flex" alignItems="center" pb={1}>
              <Box color="#E9A9B4">
                <EmailOutlined style={{ fontSize: '2rem' }} />
              </Box>
              <a href={`mailto:${companyEmail}`}>
                <Typography variant="body1" style={{ margin: '0 1em' }}>
                  {companyEmail}
                </Typography>
              </a>
            </Box>
            : null}
          </div>
        </Box>
        <Box height="300px" width={matches ? '60%' : '100%'} textAlign="center" style={{visibility: visibleMap ? 'visible' : 'hidden'}}>
          <Map
            longitude={companyData?.longitude}
            latitude={companyData?.latitude}
          />
        </Box>
      </Box>
    </Box>
    </SectionLayout>
  );
}

const TeamMember = ({ member, mainColor, data }) => {
  const { companyDomain } = data || {};
  const { id } = useParams();
  const navigate = useNavigate();
  
  const handleClick = (_id) => {
    navigate(companyDomain ? `/temp/team/${_id}` : `/${id}/temp/team/${_id}`);
  };

  return (
    <Box mr={2} mb={1} style={{cursor:"pointer"}} onClick={()=> handleClick(member?.id)}>
      <Box
        width={{ xs: '130px', md: '220px' }}
        height={{ xs: '130px', md: '220px' }}
        borderRadius="50%"
        overflow="hidden"
        border={`2px solid ${mainColor ? mainColor : '#C31B37'}`}
        p="0.2em"
        mb={2}
      >
        <ImgLazyLoad>
          <img
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
            src={member?.avatar || imgProfile}
            alt={member.name || 'team'}
          />
        </ImgLazyLoad>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography variant="subtitl1" style={{ fontWeight: 'bold',textTransform:'capitalize' }} align="center">
          {member.name}
        </Typography>
        <Typography
          variant="subtitle2"
          style={{ textTransform: 'capitalize' }}
          align="center"
        >
          {member.roleType}
        </Typography>
      </Box>
    </Box>
  );
};

export {
  About,
  Services,
  Courses,
  Teams,
  _HomeHeader
};

export default Home;
